var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAk231270(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 87.7 30",
    style: {
      enableBackground: "new 0 0 87.7 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 70.4,
    y: -6.7,
    transform: "matrix(0.4701 -0.8826 0.8826 0.4701 30.933 66.6491)",
    width: 1.2,
    height: 28.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.9,
    y: 20.8,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -1.1695 38.2842)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.1,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.4,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5,30H57.4V0h30.1V30z M58.5,28.8h27.8V1.2H58.5V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1,25.9H61.3V3.7h22.8V25.9z M62.5,24.8h20.4V4.8H62.5V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: -6.7,
    transform: "matrix(0.4701 -0.8826 0.8826 0.4701 0.5211 15.9942)",
    width: 1.2,
    height: 28.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.4,
    y: 20.8,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -8.7935 9.7011)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1,30H0V0h30.1V30z M1.2,28.8H29V1.2H1.2V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7,25.9H4V3.7h22.8V25.9z M5.1,24.8h20.4V4.8H5.1V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.7,
    y: -6.7,
    transform: "matrix(0.4701 -0.8826 0.8826 0.4701 15.7266 41.3212)",
    width: 1.2,
    height: 28.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.3,
    y: 20.8,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -4.9815 23.9926)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8,30H28.7V0h30.1V30z M29.9,28.8h27.8V1.2H29.9V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4,25.9H32.7V3.7h22.8V25.9z M33.8,24.8h20.4V4.8H33.8V24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4,30l-0.2,0c-0.3-0.1-0.4-0.5-0.3-0.8l1.4-3.3c0.1-0.3,0.5-0.4,0.8-0.3c0.3,0.1,0.4,0.5,0.3,0.8l-1.4,3.3 C58.9,29.9,58.6,30,58.4,30z M60.9,24.3l-0.2,0c-0.3-0.1-0.4-0.5-0.3-0.8l1.4-3.3c0.1-0.3,0.5-0.4,0.8-0.3c0.3,0.1,0.4,0.5,0.3,0.8 l-1.4,3.3C61.4,24.1,61.2,24.3,60.9,24.3z M63.5,18.5l-0.2,0c-0.3-0.1-0.4-0.5-0.3-0.8l1.4-3.3c0.1-0.3,0.5-0.4,0.8-0.3 c0.3,0.1,0.4,0.5,0.3,0.8L64,18.2C63.9,18.4,63.7,18.5,63.5,18.5z M66,12.8l-0.2,0c-0.3-0.1-0.4-0.5-0.3-0.8l1.4-3.3 c0.1-0.3,0.5-0.4,0.8-0.3c0.3,0.1,0.4,0.5,0.3,0.8l-1.4,3.3C66.4,12.7,66.2,12.8,66,12.8z M68.5,7.1l-0.2,0C68,6.9,67.9,6.5,68,6.2 L69.4,3c0.1-0.3,0.5-0.4,0.8-0.3c0.3,0.1,0.4,0.5,0.3,0.8L69,6.7C68.9,6.9,68.7,7.1,68.5,7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1,30c-0.2,0-0.4-0.1-0.5-0.3l-1.8-3.1c-0.2-0.3-0.1-0.6,0.2-0.8c0.3-0.2,0.6-0.1,0.8,0.2l1.8,3.1 c0.2,0.3,0.1,0.6-0.2,0.8L87.1,30z M84,24.5c-0.2,0-0.4-0.1-0.5-0.3l-1.8-3.1c-0.2-0.3-0.1-0.6,0.2-0.8c0.3-0.2,0.6-0.1,0.8,0.2 l1.8,3.1c0.2,0.3,0.1,0.6-0.2,0.8L84,24.5z M80.9,19.1c-0.2,0-0.4-0.1-0.5-0.3l-1.8-3.1c-0.2-0.3-0.1-0.6,0.2-0.8 c0.3-0.2,0.6-0.1,0.8,0.2l1.8,3.1c0.2,0.3,0.1,0.6-0.2,0.8L80.9,19.1z M77.9,13.6c-0.2,0-0.4-0.1-0.5-0.3l-1.8-3.1 c-0.2-0.3-0.1-0.6,0.2-0.8c0.3-0.2,0.6-0.1,0.8,0.2l1.8,3.1c0.2,0.3,0.1,0.6-0.2,0.8L77.9,13.6z M74.8,8.2c-0.2,0-0.4-0.1-0.5-0.3 l-1.8-3.1c-0.2-0.3-0.1-0.6,0.2-0.8c0.3-0.2,0.6-0.1,0.8,0.2l1.8,3.1c0.2,0.3,0.1,0.6-0.2,0.8L74.8,8.2z M71.7,2.7 c-0.2,0-0.4-0.1-0.5-0.3l-0.7-1.3c-0.2-0.3-0.1-0.6,0.2-0.8c0.3-0.2,0.6-0.1,0.8,0.2l0.7,1.3c0.2,0.3,0.1,0.6-0.2,0.8L71.7,2.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAk231270);
export default __webpack_public_path__ + "static/media/AK2_3_127_0.a7a6e52e9e3efc73151e1be5cb985a28.svg";
export { ForwardRef as ReactComponent };